import { Item } from 'react-photoswipe-gallery';
import styled from 'styled-components';
import { ColorBrandBlue1 } from 'autogen/design-tokens/tokens';
import { PreviewItem } from 'components/GalleryMediaPreviewer/shared/styles';
import Image from 'components/generic/Image';
import dynamic from 'helpers/dynamic';
import { sizes } from 'variables';
import type { Product360MediaItem } from '../../shared/types';
import Product360Player from './components/Product360Player';

const StyledImg = styled(Image.WithScaling)`
    width: 100%;
    height: 100%;
    object-fit: contain;
    cursor: pointer;
`;

const Arrow360Icon = dynamic(() => import('icons/Arrow360.svg?react'), { ssr: false });

const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    height: 48px;
    width: 48px;
    padding: 4px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-color: ${ColorBrandBlue1};
`;

export default function PreviewGallery360Item({ product360Item }: { product360Item: Product360MediaItem }) {
    return (
        <Item content={<Product360Player directoryUrl={product360Item.directoryUrl} />}>
            {({ ref, open }) => (
                <PreviewItem ref={ref} onClick={open}>
                    <StyledImg
                        src={product360Item.thumbnail}
                        transformType="WidthScale"
                        imageType="product"
                        sizes={[[sizes.md, 650], 240]}
                        alt="360 product preview"
                        loading="lazy"
                    />
                    <IconContainer>
                        <Arrow360Icon fill="white" width={40} height={40} />
                    </IconContainer>
                </PreviewItem>
            )}
        </Item>
    );
}
